import t from"styled-components";import{Button as o}from"../../../../../components/Button/Button.js";const n=t(o)`
  display: inline-block;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: 0.25s;
`;export{n as Button};
//# sourceMappingURL=styles.js.map
